import React, { useState, useEffect } from 'react';
import "./generator-room.css";
import Sidebar from '../../../Components/Sidebar/Sidebar';
import gr1 from "../../../Assets/generator-rooms.jpg";
import { Link } from 'react-router';
import gr2 from "../../../Assets/sound-barrier-india.webp";
import gr3 from "../../../Assets/generator-room/room-with-sound-barrier.jpg";
import gr4 from "../../../Assets/sound-barrier-manufacturer.webp";
import gr5 from "../../../Assets/generator-room/gr1.jpg";
import gr6 from "../../../Assets/generator-room/gr2.jpg";
import gr7 from "../../../Assets/generator-room/gr3.jpg";
import gr8 from "../../../Assets/generator-room/gr4.jpg";
import gr9 from "../../../Assets/generator-room/gr5.jpg";
import gr10 from "../../../Assets/generator-room/gr6.jpg";
import gr11 from "../../../Assets/generator-room/gr7.jpg";
import MFooter from '../../../Components/Main-Footer/MFooter';
import HNavbar from '../../../Components/Navbar/HNavbar';

function GeneratorRoom() {
    const [showTopBtn, setShowTopBtn] = useState(false);

    const handleClick = () => {
        const name = document.getElementById('name').value.trim();
        const mail = document.getElementById('mail').value.trim();
        const phone = document.getElementById('phone').value.trim();
        const message = document.getElementById('message').value.trim();

        const subject = `New message from ${name}`
        const body = `Name: ${name}%0AEmail: ${mail}%0APhone: ${phone}%0A%0AMessage:%0A${message}`;
        const mailtoLink = `mailto:mail@acousticalsurfaces.in?subject=${encodeURIComponent(subject)}&body=${body}`;

        window.open(mailtoLink, '_blank');

        document.getElementById('name').value = '';
        document.getElementById('mail').value = '';
        document.getElementById('phone').value = '';
        document.getElementById('message').value = '';
    }
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 400) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        };
        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    useEffect(() => {
        const animatedElements = document.querySelectorAll('.gen-header,.gen-header1,.gen-header2,.gen-header3,.gen-header4,.gen-header5,.gen-header6');

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate');
                } else {
                    entry.target.classList.remove('animate');
                }
            });
        }, { threshold: 0.3 });

        animatedElements.forEach(el => observer.observe(el));

        return () => {
            animatedElements.forEach(el => observer.unobserve(el));
        };
    }, []);
    return (
        <>
        <HNavbar />
            <section id='generator-rooms' className='home-generator'>
                <div className='container p-0'>
                    <Sidebar />
                    <div className='row main-generator-rooms'>
                        <div className='col-12 col-md-6 d-flex justify-content-center align-items-center p-3'>
                            <div className='image-wrapper'>
                                <img className='img-fluid generator-rooms-home-img' src={gr1} alt="generator-room" />
                            </div>
                        </div>
                        <div className='col-12 col-md-6 d-flex flex-column justify-content-center align-items-start text-white'>
                            <h1 className='gen-header'>Generator Room Noise Control Solutions | Sound Barrier</h1>
                            <p className='white-para'>Generator rooms produce high levels of continuous noise that can disturb employees, nearby offices, and surrounding areas. Without proper sound control, generator noise can reduce workplace comfort and create compliance issues.</p>
                            <p className='white-para'><b>Sound Barrier Manufacture</b> provides effective generator room noise control solutions using high-performance sound barrier blankets and acoustic enclosures.</p>
                            <p className='white-para'>ur systems are designed to reduce generator noise transmission and create a safer, quieter working environment.</p>
                            <Link to="/contact"><button className='btn' type="button">Contact us</button></Link>
                        </div>
                    </div>
                </div>
            </section >

            <section id='generator-rooms'>
                <div className='container noice-control mt-4'>
                    <h1 className='gen-header1'>Why Noise Control is Important in Generator Rooms</h1>
                    <div className='row'>
                        <div className='col-sm-12 col-md-6 d-flex justify-content-center'>
                            <img className='img-fluid' src={gr2} alt="generator-room" style={{ height: "500px" }} />
                        </div>
                        <div className='col-sm-12 col-md-6 d-flex flex-column align-items-start justify-content-center'>
                            <p>Generators operate for long hours and produce high decibel sound levels. Excessive generator noise can cause:</p>
                            <ul className='list'>
                                <li>Disturbance to office staff and employees</li>
                                <li>Communication difficulties in work areas</li>
                                <li>Reduced productivity</li>
                                <li>Health and safety concerns</li>
                                <li>Environmental noise regulation issues</li>
                            </ul>
                        </div>
                    </div>
                    <p>Installing proper generator room sound barriers helps maintain a controlled and comfortable workspace.</p>

                    <h1 className='gen-header2' style={{ marginTop: "10px" }}>Our Generator Room Sound Barrier Solutions</h1>
                    <p>Sound Barrier Manufacture supplies industrial-grade sound barrier blankets and acoustic systems specially designed for generator noise control.</p>
                    <div className='row mt-5'>
                        <div className='col-sm-12 col-md-6'>
                            <h5>Key Features:</h5>
                            <ul className='list'>
                                <li>High STC-rated sound barrier material</li>
                                <li>Heat-resistant and durable outer layer</li>
                                <li>Fire-retardant options available</li>
                                <li>Suitable for indoor and semi-outdoor use</li>
                                <li>Easy installation around generator rooms</li>
                                <li>Custom size and thickness options</li>
                                <li>Reusable and long-lasting performance</li>
                            </ul>
                            <p>Our sound barriers can be used as temporary enclosures or permanent acoustic solutions.</p>
                        </div>
                        <div className='col-sm-12 col-md-6'>
                            <img className='img-fluid' src={gr3} alt="generator-rooms" style={{ height: "400px" }} />
                        </div>
                    </div>

                    <h1 className='gen-header3' style={{ marginTop: "30px" }}>Benefits of Generator Room Noise Control</h1>
                    <div className='row'>
                        <div className='col-sm-12 col-md-6'>
                            <img className='img-fluid' src={gr4} alt="generator-room" />
                        </div>
                        <div className='col-sm-12 col-md-6 d-flex flex-column align-items-start justify-content-center'>
                            <p>Using generator room sound barriers helps:</p>
                            <ul className='list'>
                                <li>Reduce noise levels outside the generator room</li>
                                <li>Protect employees from excessive sound exposure</li>
                                <li>Improve workplace comfort</li>
                                <li>Meet safety and environmental standards</li>
                                <li>Enhance overall building acoustic performance</li>
                            </ul>
                        </div>
                    </div>
                    <h1 className='gen-header4' style={{ marginTop: "20px" }}>Applications</h1>
                    <h4 className='sub-title mt-3'>Our generator room noise control solutions are suitable for:</h4>
                    <div className='row'>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={gr5} alt="Commercial buildings" />
                            <p>Commercial buildings</p>
                        </div>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={gr6} alt="Corporate offices" />
                            <p>Corporate offices</p>
                        </div>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={gr7} alt="Hospitals" />
                            <p>Hospitals</p>
                        </div>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={gr8} alt="Hotels" />
                            <p>Hotels</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-sm-4 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={gr9} alt="Industrial facilities" />
                            <p>Industrial facilities</p>
                        </div>
                        <div className='col-sm-4 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={gr10} alt="Residential complexes" />
                            <p>Residential complexes</p>
                        </div>
                        <div className='col-sm-4 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={gr11} alt="Data centers" />
                            <p>Data centers</p>
                        </div>
                    </div>
                </div>
            </section>

            <section id='generator-rooms' className='call'>
                <div className='container'>
                    <h1 className='gen-header5'>Why Choose Us?</h1>

                    <ul className='gen-list white-para'>
                        <li>Experienced industrial noise control provider</li>
                        <li>High-performance generator room sound barriers</li>
                        <li>Custom manufacturing capability</li>
                        <li>Quick supply and installation support</li>
                        <li>Cost-effective noise control systems</li>
                    </ul>
                    <p className='white-para'>We provide reliable soundproofing solutions designed to control generator noise and protect working employees.</p>

                    <h1 className='gen-header6'>Contact Us for Generator Room Noise Control Solutions</h1>
                    <div className='row'>
                        <div className='col-sm-12 col-md-6'>
                            <p className='white-para'>Looking for professional generator room noise control systems?</p>
                            <p className='white-para'>Sound Barrier Manufacture delivers customized sound barrier solutions to reduce generator noise and create a quieter working environment.</p>
                            <p className='white-para'>Contact us today for expert consultation and site-specific acoustic solutions.</p>
                        </div>
                        <div className='col-sm-12 col-md-6'>
                            <div className="row">
                                <div className="col-sm-12 col-md-4 mb-3">
                                    <input
                                        type="text"
                                        name="name"
                                        id="name"
                                        className="form-control"
                                        placeholder="Name *"
                                    />
                                </div>
                                <div className="col-sm-12 col-md-4 mb-3">
                                    <input
                                        type="email"
                                        name="mail"
                                        id="mail"
                                        className="form-control"
                                        placeholder="Email *"
                                    />
                                </div>
                                <div className="col-sm-12 col-md-4 mb-3">
                                    <input
                                        type="text"
                                        name="phone"
                                        id="phone"
                                        className="form-control"
                                        placeholder="Phone *"
                                    />
                                </div>
                                <div className="col-12 mb-3">
                                    <textarea
                                        rows={4}
                                        id="message"
                                        className="form-control"
                                        placeholder="Message *"
                                    ></textarea>
                                </div>
                                <div className="col-12">
                                    <button
                                        className="btn"
                                        type="button"
                                        onClick={handleClick}
                                    >
                                        SEND
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {showTopBtn && (
                <button className='scroll-to-top'
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                > ↑ </button>
            )
            }
            <MFooter />
        </>
    )
}

export default GeneratorRoom